module.exports = __webpack_public_path__ + "static/media/bannerTablet@2x.9b25bad8.jpg";